import { Component, Input } from '@angular/core';
import { FormGroupType } from '@app/core/utils/formgroup-type';
import {
  CreateMeteringPointCommand,
  ObservationTimeSeriesPeriod,
  SettlementMethod,
  UpdateMeteringPointCommand
} from '@app/api/dmc';
import { ReactiveFormsModule } from '@angular/forms';
import { GuideCardComponent } from '@shared/components/guide-card/guide-card.component';
import { TranslatePipe } from '@ngx-translate/core';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { SelectDirective } from '@shared/components/input/select/select.directive';
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { enumToKeyValue } from '@app/core/utils/enum-to-key-value';

@Component({
  selector: 'app-meteringpoint-form-reading-billing',
  imports: [
    ReactiveFormsModule,
    GuideCardComponent,
    TranslatePipe,
    InputGroupComponent,
    LabelDirective,
    SelectDirective
  ],
  templateUrl: './meteringpoint-form-reading-billing.component.html',
  styleUrl: './meteringpoint-form-reading-billing.component.css'
})
export class MeteringpointFormReadingBillingComponent {
  @Input() public form!: FormGroupType<CreateMeteringPointCommand | UpdateMeteringPointCommand>;

  @Input() public fullWidth: boolean = true;

  /** Populated Lists **/
  public meterReadingOccurrenceList: KeyValue[] = enumToKeyValue(ObservationTimeSeriesPeriod, { includeKeys: ['Hour', 'Quarter'], prefixValue: 'enum.resolution.' });
  public settlementMethodList: KeyValue[] = enumToKeyValue(SettlementMethod, { omitKeys: ['NotSpecified', 'Profiled'], prefixValue: 'enum.meteringpoint.settlementmethod.' });

}
